import { useMutation } from 'react-query';
import {
  createGeneralRecognitionAsync,
  getGeneralRecognitionByIdAsync,
  updateGeneralRecognitionAsync,
} from '../../index';

export const useCreateGeneralRecognitionAsync = () =>
  useMutation(createGeneralRecognitionAsync);

export const useUpdateGeneralRecognitionAsync = () =>
  useMutation(updateGeneralRecognitionAsync);

export const useGetGeneralRecognitionByIdAsync = () =>
  useMutation(getGeneralRecognitionByIdAsync);
